import axios from 'axios'
import { UrlBase } from './config'

const forms = {}

forms.createForm = (token, companyId, appId, data) => {
  const { name, code, description, rolId, loginRequired, email, phone, fields, options, registerForm, sendEmail, sendSMS } = data
  return new Promise((resolve, reject) => {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/forms',
      data: {
        name,
        code,
        description,
        rolId,
        loginRequired,
        email: !email.subject || !email.to ? undefined : email,
        phone: !phone.phone.phone || !phone.phone.number ? undefined : {
          number: phone.phone.phone,
          countryCode: phone.phone.number,
          message: phone.message
        },
        fields,
        options,
        registerForm,
        sendEmail,
        sendSMS
      }
    }
    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) return reject(new Error(error.message))
        else return reject(new Error(message.data.error))
      })
  })
}

forms.getForm = async (companyId, appId, formId) => {
  try {
    const request = {
      method: 'GET',
      params: {
        id: formId
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/forms'
    }

    const response = await axios(request)

    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

forms.getForms = (token, companyId, appId, pagination, search) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.descending,
        // limit: pagination.itemsPerPage,
        name: search
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/forms'
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.log(error)
      })
  })
}

forms.getFormSubmits = (token, companyId, appId, formId, pagination) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.descending,
        // limit: pagination.itemsPerPage,
        formId: formId
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/forms/submits'
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.log(error)
      })
  })
}

forms.updateForm = async (companyId, appId, data) => {
  const { _id, name, code, description, rolId, loginRequired, email, phone, fields, options, registerForm, sendEmail, sendSMS } = data

  try {
    const request = {
      method: 'PUT',
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/forms/' + _id,
      data: {
        name,
        code,
        description,
        rolId,
        loginRequired,
        email: !email.subject || !email.to ? undefined : email,
        phone: !phone.phone.phone || !phone.phone.number ? undefined : {
          number: phone.phone.phone,
          countryCode: phone.phone.number,
          message: phone.message
        },
        fields,
        options,
        registerForm,
        sendEmail,
        sendSMS
      }
    }

    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

forms.downloadFile = (token, companyId, appId, { submitId, indexFile, filename }) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'GET',
      responseType: 'blob',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/forms/submits/' + submitId + '/file',
      params: {
        number: indexFile
      }
    }
    axios(request)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        resolve(true)
      })
      .catch(error => {
        console.log(error)
      })
  })
}

forms.exportFormSubmits = (token, companyId, appId, formId, { filename }) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'GET',
      responseType: 'blob',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/forms/' + formId + '/export/excel'
    }
    axios(request)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${filename}.xlsx`)
        document.body.appendChild(link)
        link.click()
        resolve(true)
      })
      .catch(error => {
        const message = error.response
        if (!message) return reject(new Error(error.message))
        else return reject(new Error(message.data.error))
      })
  })
}

export default forms
